<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["payment_method"] }}
        </p>
      </div>
      <p class="content_title">
        {{
          this.$store.getters.USER.selectedCard.id ===
          this.$store.getters.USER.defaultCardId
            ? "DEFAULT ACCOUNT"
            : "ADDITONAL ACCOUNT"
        }}
      </p>
      <input
        type="text"
        v-model="number"
        :placeholder="this.$store.getters.TRANSLATIONS['credit_card_number']"
        class="number"
        autocomplete="off"
        disabled
      />
      <!-- <div class="card-wrapper">
        <input
          type="text"
          v-model="expire"
          placeholder="MM/YY"
          class="box expire"
          autocomplete="off"
          disabled
        />
        <input
          type="text"
          v-model="cvv"
          placeholder="CVV"
          class="box cvv"
          autocomplete="off"
          disabled
        />
      </div>

      <input
        type="text"
        v-model="zip"
        placeholder="ZIP"
        class="zip"
        autocomplete="off"
        disabled
      />-->
    </div>
    <div class="footer" v-if="!loading">
      <button
        v-if="
          this.$store.getters.USER.selectedCard.id !==
          this.$store.getters.USER.defaultCardId
        "
        v-on:click="setAsDefault()"
        class="button set_default"
      >
        {{ this.$store.getters.TRANSLATIONS["set_default"] }}
      </button>
      <button
        v-if="
          this.$store.getters.USER.selectedCard.id !==
          this.$store.getters.USER.defaultCardId
        "
        v-on:click="removeCard()"
        class="button remove"
      >
        {{ this.$store.getters.TRANSLATIONS["remove"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%; text-align: center" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      number: this.$store.getters.USER.selectedCard.number,
      expire: this.$store.getters.USER.selectedCard.expire,
      cvv: this.$store.getters.USER.selectedCard.cvv,
      zip: this.$store.getters.USER.selectedCard.zip,
      removeCard: () => {
        this.$modal.show("dialog", {
          text: this.$store.getters.TRANSLATIONS["are_you_sure"],
          buttons: [
            {
              title: this.$store.getters.TRANSLATIONS["no"]
            },
            {
              title: this.$store.getters.TRANSLATIONS["yes"],
              handler: () => {
                /////

                const timeout = setTimeout(() => {
                  this.loading = true;
                }, 0);
                this.$http
                  .delete(
                    `${process.env.SERVER_URL}/980B0B6229DA4D59AB6D583F82ACCE98/${this.$store.getters.USER.selectedCard.id}`,
                    {
                      headers: {
                        "x-access-token": this.$storage.get("parkendaToken")
                      }
                    }
                  )
                  .then((response) => {
                    console.log("Delete card response");
                    console.log(response);
                    if (
                      response.data &&
                      response.status &&
                      response.status === 200
                    ) {
                      this.$router.push("/cardsListSquare");
                    }
                  })
                  .catch((error) => {
                    let text =
                      this.$store.getters.TRANSLATIONS["something_went_wrong"];
                    if (
                      error.response &&
                      error.response.data &&
                      error.response.data.error
                    ) {
                      text = error.response.data.error;
                    }
                    this.$modal.show("dialog", {
                      text,
                      buttons: [
                        {
                          title: "OK",
                          handler: () => {
                            this.$router.push("/cardsListSquare");
                          }
                        }
                      ]
                    });
                  })
                  .finally(() => {
                    clearTimeout(timeout);
                    this.loading = false;
                  });

                /////
              }
            }
          ]
        });
      },
      setAsDefault: () => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(
            `${process.env.SERVER_URL}/67E378C404C74A98AAEF1FA165EEF424`,
            {
              defaultCardId: this.$store.getters.USER.selectedCard.id
            },
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Set default card response");
            console.log(response);
            if (response.data && response.status && response.status === 200) {
              let USER = this.$store.getters.USER;
              USER.defaultCardId = USER.selectedCard.id;
              this.$store.dispatch("SAVE_USER", USER);
              this.$router.push("/cardsListSquare");
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              text = error.response.data.error;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$router.push("/cardsListSquare");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      addCardSkip: () => {
        this.$router.push("/parkendaValet");
      },
      back: () => {
        this.$router.go(-1);
      },
      icon: require("@/assets/icon_back.png")
    };
  }
};
</script>

<style src="../../styles/main.css"></style>
<style scoped>
input {
  background: transparent !important;
  margin: 0 17vw;
  color: rgba(114, 174, 255, 1) !important;
  border: 0;
  outline: 0;
  border-bottom: 1px solid rgba(114, 174, 255, 1);
}
.set_default {
  background-color: white;
  color: #fbae31;
}
.remove {
  background-color: red;
  color: white;
}
.footer {
  height: 25vh;
}
</style>



// WEBPACK FOOTER //
// src/components/Cards/Edit.vue